(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.controller('CheckoutController', ['$scope', '$rootScope', '$http', 'stripe', '$uibModal', '$uibModalInstance', 'store', 'storeId', '$state', '$q', '$templateCache', '$compile', '$Orders', '$timeout', function($scope, $rootScope, $http, stripe, $uibModal, $uibModalInstance, store, storeId, $state, $q, $templateCache, $compile, $Orders, $timeout ) {

        angular.extend($scope, {});

        // console.log('store store store store -> ', store);
        // console.log('rootscope cart', $rootScope.cart);
        $scope.processing = false;
        $scope.card = {};
        $scope.errorResponse = '';
        $scope.store = store;
        $scope.order = {
            isThisYours: 'Yes'
        };

        $scope.emptyCart = () => {
            $rootScope.$emit('cart.empty');
        };

        $scope.showCart = () => {

            $uibModalInstance.close();

            $rootScope.$emit('cart.show');
        };

        $scope.formSubmit = function() {

            $scope.processing = true;

            let status = 'Pending';

            let order = angular.copy($rootScope.cart);

            angular.extend(order, {
                checkoutDetails: $scope.order,
                storeId: storeId,
                storeName: store.name,
                storeTeam: store.team,
                paymentType: $scope.order.paymentType,
                status: status,
                timestamp: Date.now()
            });

            console.log('the extended order', order);

            if($scope.order.paymentType === 'credit'){

                stripe.card.createToken({
                    name: $scope.order.orderedBy,
                    number: $scope.card.number,
                    cvc: $scope.card.cvc,
                    exp_month: $scope.card.exp_month,
                    exp_year: $scope.card.exp_year
                    //zip_code:
                })
                .then(function (response) {

                    console.log('received token', response, store);
                    // console.log('which response is this', response);
                    $scope.card = void 0;

                    var queryString = $.param({
                      stripeToken:response.id,
                      amount: Math.trunc( $rootScope.cart.total * 100 ), // bascially removes the decimals since stripe does amount in pennies, e.g. 500 = $5.00
                      orderInfo: 'Breakmark Custom Team Apparel: ' + store.team + ' - ' + store.name
                    })

                    return $http.post('https://wt-jesse-ossium_co-0.sandbox.auth0-extend.com/stripeServer?'+queryString);

                })
                .then(function(response) {

                    console.log('a further response', response, store);

                    order.status = 'Paid';

                    console.log('addOrderToStore, credit card', storeId, order);

                    $Orders.addOrderToStore(storeId,order).then( (returnedOrder) => {

                        console.log('addOrderToStore -> credit card order', returnedOrder);

                        $scope.emptyCart();

                        $uibModalInstance.close();

                        $scope.sendReceipts(returnedOrder);

                    });

                })
                .catch(function (err) {

                    console.log('error', err);

                    if (err.type && /^Stripe/.test(err.type)) {
                        console.log('Stripe error: ', err.message);
                    }
                    else {
                        console.log('Non-stripe error: ', err.message);

                        alert(err.message);

                        $scope.errorResponse = err.message;

                        // $uibModal.open({
                        //     animation: true,
                        //     templateUrl:'directives/externalStore/cardError.html',
                        //     controller: function($scope, err) {
                        //
                        //         $scope.err = err;
                        //
                        //         $scope.close = function() {
                        //             $uibModalInstance.close();
                        //         }
                        //     },
                        //     resolve: {
                        //         err: function() {
                        //             return err;
                        //         }
                        //     }
                        // });
                    }
                });

            } else {

                console.log('addOrderToStore, not a credit card', storeId, order);

                $Orders.addOrderToStore(storeId,order).then( (returnedOrder) => {

                    console.log('addOrderToStore -> not a credit card order', returnedOrder);

                    $scope.emptyCart();

                    $uibModalInstance.close();
                    // maui
                    $scope.sendReceipts(returnedOrder);

                });

            }

        };

        $scope.sendReceipts = (returnedOrder) => {

            console.log('sendReceipts -> order ->', returnedOrder);

            var scope = angular.extend($scope.$new(), {
                order: returnedOrder
            });

            let template = $templateCache.get('directives/externalStore/customerReceiptEmailTemplate.html');

            // console.log('template -> ', template);

            let el = $compile(template)(scope);

            // console.log('message html ->', el.html());

            $timeout(function() {

              var queryString = $.param({
                emailTo: returnedOrder.checkoutDetails.email,
                emailFrom: 'Breakmark Team Store <teamstore@breakmark.com>',
                subject: returnedOrder.storeName + ' Order',
                message: el.html()
              })

                $http.post('https://wt-jesse-ossium_co-0.sandbox.auth0-extend.com/emailServer?'+queryString).then( (response) => {

                    // console.log('send email -> email success', response);
                    var anotherQueryString = $.param({
                      // emailTo:'teamstore@breakmark.com,',
                      // emailTo: 'jesse@ossium.co',
                      emailTo: 'sales@breakmark.com',
                      emailFrom: 'Breakmark Team Store <teamstore@breakmark.com>',
                      subject: returnedOrder.storeName + ' Order Notification',
                      message: el.html()
                    })

                    $http.post('https://wt-jesse-ossium_co-0.sandbox.auth0-extend.com/emailServer?'+anotherQueryString);

                }, (errorResponse) => {

                    // console.log('send email -> errorResponse', errorResponse);

                    alert('There was an issue in trying to send you a receipt.');

                });

            }, 2000);

            $scope.processing = false;

            $state.go('singleOrder', {
                orderId: returnedOrder.$id,
                id: returnedOrder.storeId
            });
        }
    }]);

})();
